import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import {
  HttpResponse,
  ResendUserInvitationRequest,
  ResendUserInvitationResponse,
} from "@/types";

export function useResendUserInvitation() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({
      resendUserInvitationRequest,
    }: {
      resendUserInvitationRequest: ResendUserInvitationRequest;
    }) => {
      const path = `companies/${currentCompanyId}/user-invitations/resend`;
      const res = await guacHttpClient.post<
        ResendUserInvitationResponse,
        HttpResponse<ResendUserInvitationResponse>,
        ResendUserInvitationRequest
      >(path, resendUserInvitationRequest);

      return res.data;
    },
  });

  return mutation;
}
